module.exports = __webpack_public_path__ + "img/ext.9d0600e0.jpeg";